var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1719107378427,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 11860,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.333333 447.018667C85.333333 555.178667 194.133333 896 447.018667 896H896a42.666667 42.666667 0 0 0 38.186667-61.866667c-1.194667-2.133333-109.866667-220.458667-109.866667-365.482666 0-149.973333 31.36-286.976 31.658667-288.298667A42.837333 42.837333 0 0 0 814.378667 128H182.485333a42.666667 42.666667 0 0 0-40.832 30.293333C139.349333 165.888 85.333333 344.32 85.333333 447.061333zM488.533333 682.666667H298.666667V341.333333h68.821333v284.16h121.002667z m248.96-283.818667H653.226667V682.666667h-69.162667V398.848h-83.029333V341.333333h236.501333z",
    fill: "#333",
    "p-id": 11861
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLt);
export default __webpack_public_path__ + "static/media/lt.531644b5a899b51d46c3b252daeb167c.svg";
export { ForwardRef as ReactComponent };